const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();

export const BACKEND_URL = rawBackendUrl.replace(/\/+$/, "");
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
